// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file devtool/emodel/v1/pfe_service.proto (package devtool.emodel.v1, syntax proto3)
/* eslint-disable */

// A verbatim mirror of eModel's pfe_service.proto (enechain/service-proto,
// services/emodel/emodel/v1), in a package this repository owns: eposition-app's
// protos do not import another service's protos, but the dev-tool RPCs carry
// eModel requests and responses as their own.
//
// Field numbers and types match emodel.v1 exactly. That is what lets
// devtoolemodel.Convert translate by re-encoding instead of copying field by
// field, so any change to eModel's messages has to be mirrored here by hand —
// TestMirrorMatchesEmodel fails if the two ever drift.

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import type { CollateralConfig } from "./common_model_pb";
import { file_devtool_emodel_v1_common_model } from "./common_model_pb";
import type { ICSData, IMPortfolioItem, IMPortfolioResult, PSRData, PSRDataForFloatingIndex, PSRDataSource, ResultDetailLevel } from "./im_model_pb";
import { file_devtool_emodel_v1_im_model } from "./im_model_pb";
import type { DiscountingConfig, MarketQuote, PFECalculationMode, QuantileResult, ScenarioDataSet, ScenarioInfo, ScenarioSelection, ScenarioSource, Trade } from "./pfe_model_pb";
import { file_devtool_emodel_v1_pfe_model } from "./pfe_model_pb";
import type { Date } from "../../../google/type/date_pb";
import { file_google_type_date } from "../../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file devtool/emodel/v1/pfe_service.proto.
 */
export const file_devtool_emodel_v1_pfe_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_devtool_emodel_v1_common_model, file_devtool_emodel_v1_im_model, file_devtool_emodel_v1_pfe_model, file_google_type_date]);

/**
 * @generated from message devtool.emodel.v1.ListScenarioDataSetsRequest
 */
export type ListScenarioDataSetsRequest = Message<"devtool.emodel.v1.ListScenarioDataSetsRequest"> & {
  /**
   * Optional filter; server currently returns the same underlying dataset list.
   *
   * @generated from field: optional devtool.emodel.v1.ScenarioSource scenario_source = 1;
   */
  scenarioSource?: ScenarioSource;
};

/**
 * Describes the message devtool.emodel.v1.ListScenarioDataSetsRequest.
 * Use `create(ListScenarioDataSetsRequestSchema)` to create a new message.
 */
export const ListScenarioDataSetsRequestSchema: GenMessage<ListScenarioDataSetsRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_service, 0);

/**
 * @generated from message devtool.emodel.v1.ListScenarioDataSetsResponse
 */
export type ListScenarioDataSetsResponse = Message<"devtool.emodel.v1.ListScenarioDataSetsResponse"> & {
  /**
   * @generated from field: repeated devtool.emodel.v1.ScenarioDataSet data_sets = 1;
   */
  dataSets: ScenarioDataSet[];

  /**
   * Active dataset id for the requested source.
   *
   * @generated from field: string active_data_set_id = 2;
   */
  activeDataSetId: string;
};

/**
 * Describes the message devtool.emodel.v1.ListScenarioDataSetsResponse.
 * Use `create(ListScenarioDataSetsResponseSchema)` to create a new message.
 */
export const ListScenarioDataSetsResponseSchema: GenMessage<ListScenarioDataSetsResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_service, 1);

/**
 * CalculatePFERequest is the request for PFE calculation.
 *
 * @generated from message devtool.emodel.v1.CalculatePFERequest
 */
export type CalculatePFERequest = Message<"devtool.emodel.v1.CalculatePFERequest"> & {
  /**
   * Base date for calculation (required).
   * Used for tenor calculation and historical data reference.
   *
   * @generated from field: google.type.Date base_date = 1;
   */
  baseDate?: Date;

  /**
   * Quantiles to calculate in basis points (1/10000).
   * e.g., 99.9% = 9990, 99% = 9900, 95% = 9500.
   *
   * @generated from field: repeated int32 quantiles = 3;
   */
  quantiles: number[];

  /**
   * Number of evaluation days (optional, default: 365).
   *
   * @generated from field: optional int32 evaluation_days = 4;
   */
  evaluationDays?: number;

  /**
   * Calculation mode (optional, default: FAST_VOLATILITY).
   *
   * @generated from field: optional devtool.emodel.v1.PFECalculationMode calculation_mode = 6;
   */
  calculationMode?: PFECalculationMode;

  /**
   * Scenario volatility data set ID (optional, uses active set if not specified).
   * The dataset is interpreted as scenario volatility samples (sigma) per ticker.
   *
   * @generated from field: optional string scenario_volatility_data_set_id = 7;
   */
  scenarioVolatilityDataSetId?: string;

  /**
   * Trades to calculate PFE for (ticker-based).
   *
   * @generated from field: repeated devtool.emodel.v1.Trade trades = 8;
   */
  trades: Trade[];

  /**
   * Base market quotes (used in REPRICING mode; optional in FAST mode).
   *
   * @generated from field: repeated devtool.emodel.v1.MarketQuote base_market_quotes = 9;
   */
  baseMarketQuotes: MarketQuote[];

  /**
   * Scenario selection (optional).
   *
   * @generated from field: optional devtool.emodel.v1.ScenarioSelection scenario_selection = 10;
   */
  scenarioSelection?: ScenarioSelection;

  /**
   * Scenario source (optional, default: VOLATILITY).
   *
   * @generated from field: optional devtool.emodel.v1.ScenarioSource scenario_source = 11;
   */
  scenarioSource?: ScenarioSource;

  /**
   * Historical scenario dataset id (optional, uses active set if not specified).
   *
   * @generated from field: optional string scenario_historical_data_set_id = 12;
   */
  scenarioHistoricalDataSetId?: string;

  /**
   * Discounting config (optional; default disabled).
   *
   * @generated from field: optional devtool.emodel.v1.DiscountingConfig discounting = 13;
   */
  discounting?: DiscountingConfig;

  /**
   * Collateral (VM) simulation config (optional; default disabled).
   *
   * @generated from field: optional devtool.emodel.v1.CollateralConfig collateral = 14;
   */
  collateral?: CollateralConfig;
};

/**
 * Describes the message devtool.emodel.v1.CalculatePFERequest.
 * Use `create(CalculatePFERequestSchema)` to create a new message.
 */
export const CalculatePFERequestSchema: GenMessage<CalculatePFERequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_service, 2);

/**
 * CalculatePFEResponse is the response from PFE calculation.
 *
 * @generated from message devtool.emodel.v1.CalculatePFEResponse
 */
export type CalculatePFEResponse = Message<"devtool.emodel.v1.CalculatePFEResponse"> & {
  /**
   * Results for each quantile.
   *
   * @generated from field: repeated devtool.emodel.v1.QuantileResult results = 1;
   */
  results: QuantileResult[];

  /**
   * Scenario metadata used for calculation (for UI verification).
   *
   * @generated from field: optional devtool.emodel.v1.ScenarioInfo scenario_info = 2;
   */
  scenarioInfo?: ScenarioInfo;
};

/**
 * Describes the message devtool.emodel.v1.CalculatePFEResponse.
 * Use `create(CalculatePFEResponseSchema)` to create a new message.
 */
export const CalculatePFEResponseSchema: GenMessage<CalculatePFEResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_service, 3);

/**
 * CalculateInitialMarginRequest is the request for IM calculation.
 *
 * @generated from message devtool.emodel.v1.CalculateInitialMarginRequest
 */
export type CalculateInitialMarginRequest = Message<"devtool.emodel.v1.CalculateInitialMarginRequest"> & {
  /**
   * @generated from field: google.type.Date trade_date = 1;
   */
  tradeDate?: Date;

  /**
   * @generated from field: optional google.type.Date reference_date = 2;
   */
  referenceDate?: Date;

  /**
   * @generated from field: repeated devtool.emodel.v1.IMPortfolioItem portfolio = 3;
   */
  portfolio: IMPortfolioItem[];

  /**
   * @generated from field: devtool.emodel.v1.PSRDataSource psr_data_source = 4;
   */
  psrDataSource: PSRDataSource;

  /**
   * @generated from field: devtool.emodel.v1.ResultDetailLevel detail_level = 5;
   */
  detailLevel: ResultDetailLevel;

  /**
   * @generated from field: optional int32 ics_lookback_days = 6;
   */
  icsLookbackDays?: number;
};

/**
 * Describes the message devtool.emodel.v1.CalculateInitialMarginRequest.
 * Use `create(CalculateInitialMarginRequestSchema)` to create a new message.
 */
export const CalculateInitialMarginRequestSchema: GenMessage<CalculateInitialMarginRequest> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_service, 4);

/**
 * CalculateInitialMarginResponse is the response from IM calculation.
 *
 * @generated from message devtool.emodel.v1.CalculateInitialMarginResponse
 */
export type CalculateInitialMarginResponse = Message<"devtool.emodel.v1.CalculateInitialMarginResponse"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: repeated devtool.emodel.v1.IMPortfolioResult results = 2;
   */
  results: IMPortfolioResult[];

  /**
   * @generated from field: int32 runtime_ms = 3;
   */
  runtimeMs: number;

  /**
   * @generated from field: repeated devtool.emodel.v1.PSRData psr_data = 4;
   */
  psrData: PSRData[];

  /**
   * @generated from field: repeated devtool.emodel.v1.ICSData ics_data = 5;
   */
  icsData: ICSData[];

  /**
   * @generated from field: repeated devtool.emodel.v1.PSRDataForFloatingIndex psr_data_for_floating_index = 6;
   */
  psrDataForFloatingIndex: PSRDataForFloatingIndex[];
};

/**
 * Describes the message devtool.emodel.v1.CalculateInitialMarginResponse.
 * Use `create(CalculateInitialMarginResponseSchema)` to create a new message.
 */
export const CalculateInitialMarginResponseSchema: GenMessage<CalculateInitialMarginResponse> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_pfe_service, 5);

